export const WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
export const WEEKDAYS_FULL = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

export const getMonthDays = (date) => {
  const year = date.getFullYear();
  const month = date.getMonth();
  
  const firstDay = new Date(year, month, 1);
  const lastDay = new Date(year, month + 1, 0);
  const prevLastDay = new Date(year, month, 0);
  
  const firstDayOfWeek = firstDay.getDay();
  const lastDate = lastDay.getDate();
  const prevLastDate = prevLastDay.getDate();
  
  const days = [];
  
  // Previous month days
  for (let i = firstDayOfWeek - 1; i >= 0; i--) {
    const day = prevLastDate - i;
    days.push({
      date: day,
      isCurrentMonth: false,
      isToday: false,
      dateString: formatDate(new Date(year, month - 1, day))
    });
  }
  
  // Current month days
  const today = new Date();
  for (let i = 1; i <= lastDate; i++) {
    const currentDay = new Date(year, month, i);
    days.push({
      date: i,
      isCurrentMonth: true,
      isToday: isSameDay(currentDay, today),
      dateString: formatDate(currentDay)
    });
  }
  
  // Next month days - only add enough to complete the current week
  const remainingDays = 7 - (days.length % 7);
  if (remainingDays < 7) {
    for (let i = 1; i <= remainingDays; i++) {
      days.push({
        date: i,
        isCurrentMonth: false,
        isToday: false,
        dateString: formatDate(new Date(year, month + 1, i))
      });
    }
  }
  
  return days;
};

const formatDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const isSameDay = (date1, date2) => {
  return date1.getFullYear() === date2.getFullYear() &&
         date1.getMonth() === date2.getMonth() &&
         date1.getDate() === date2.getDate();
};

export const getWeekDays = (date) => {
  const currentDay = new Date(date);
  const dayOfWeek = currentDay.getDay();
  const startOfWeek = new Date(currentDay);
  startOfWeek.setDate(currentDay.getDate() - dayOfWeek);
  
  const days = [];
  const today = new Date();
  
  for (let i = 0; i < 7; i++) {
    const day = new Date(startOfWeek);
    day.setDate(startOfWeek.getDate() + i);
    
    days.push({
      date: day.getDate(),
      isCurrentMonth: day.getMonth() === date.getMonth(),
      isToday: isSameDay(day, today),
      dateString: formatDate(day)
    });
  }
  
  return days;
};

export const getWeekRange = (date) => {
  const currentDay = new Date(date);
  const dayOfWeek = currentDay.getDay();
  const startOfWeek = new Date(currentDay);
  startOfWeek.setDate(currentDay.getDate() - dayOfWeek);
  
  const endOfWeek = new Date(startOfWeek);
  endOfWeek.setDate(startOfWeek.getDate() + 6);
  
  const startDay = startOfWeek.getDate();
  const startMonth = startOfWeek.toLocaleDateString('en-US', { month: 'short' });
  const endDay = endOfWeek.getDate();
  const endMonth = endOfWeek.toLocaleDateString('en-US', { month: 'short' });
  
  return `${startDay} ${startMonth} - ${endDay} ${endMonth}`;
};
